/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_RevokeInputs */

const cs_import_tokens_revoke = /** @type {(inputs: Import_Tokens_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit`)
};

const en_import_tokens_revoke = /** @type {(inputs: Import_Tokens_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke`)
};

/**
* | output |
* | --- |
* | "Revoke" |
*
* @param {Import_Tokens_RevokeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_revoke = /** @type {((inputs?: Import_Tokens_RevokeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_RevokeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_revoke(inputs)
	return cs_import_tokens_revoke(inputs)
});